document.addEventListener('DOMContentLoaded', () => {
  const urlParams = new URLSearchParams(window.location.search);
  const pageParam = +urlParams.get('page');

  if (pageParam > 1) {
    const recipeGrid = document.querySelector('.recipe-grid');
    recipeGrid.scrollIntoView({ behavior: "instant" });
  }
})